export default __webpack_public_path__ + "static/media/Group_18923.8de80633.png";